module.exports = __webpack_public_path__ + "img/33.13ec52ee.png";